jQuery(function ($) {
    $('.give-tributes-show-wrap-li input[name="give_tributes_show_dedication"]').on('click', function(){

        var radios = $('.give-tributes-show-wrap-li input[name="give_tributes_show_dedication"]');

        radios.attr('checked', false);

        $(this).attr('checked', 'checked');
        setTimeout(function(){
            jQuery(window).trigger('resize').trigger('scroll');
        }, 100);
    });

    $('li input[name="give_tributes_radio_type"]').on('click', function(){

        var radios = $('li input[name="give_tributes_radio_type"]');

        radios.attr('checked', false);

        $(this).attr('checked', 'checked');
        setTimeout(function(){
            jQuery(window).trigger('resize').trigger('scroll');
        }, 100);

    });

    $('li input[name="give_tributes_would_to"]').on('click', function(){

        var radios = $('li input[name="give_tributes_would_to"]');

        radios.attr('checked', false);

        $(this).attr('checked', 'checked');
        setTimeout(function(){
            jQuery(window).trigger('resize').trigger('scroll');
        }, 100);

    });

    $('li input[name="payment-mode"]').on('click', function(){
        setTimeout(function(){
            jQuery(window).trigger('resize').trigger('scroll');
        }, 100);
    });

    $('label[for*="give-tributes-none"]').text('No, thank you');

    if ('.give-recurring-multilevel-label') {

        var regex = /[!"#%&'()*+,-./:;<=>?@[\]^_`{|}~]/g;

        $('.give-recurring-multilevel-label').remove();

        var amounts = $('.give-donation-level-btn').toArray();

        $(amounts).each(function() {
            $(this).text($(this).text().replace(regex, ''));
        });

    }

    var period = $('input[name="give-recurring-period"]');

    if (period.data("period" === 'year')) {
        $('.give-recurring-donors-choice label ').after('<p style="font-size: 14px; margin-top: 1.5rem">By choosing to make your donation yearly you will receive a reminder email in one year\'s time letting you know your donation will reoccur automatically.</p>')
    }

    $('.give-btn').click(function() {
        setTimeout(function(){
            var amount = $('.give-final-total-amount').text();

            $('.amount').text(amount);
        }, 100);
    });


    var currency = $('.give-currency-position-before');

    if (currency.text() === '$') {
        $(currency).text('US $');
    }
});

jQuery(function ($) {
    form = window.location.hash;

    $( document ).ready(function() {

        jQuery(window).trigger('resize').trigger('scroll');

        var checkExist = setInterval(function () {
            if ($('.donation-security')) {
                jQuery('label[for="card-number-element"]').first().text('Card Number');

                jQuery('.donation-security').closest('.v_fr').css('background', '#e5e5e5');
                jQuery('.donation-security').closest('.v_fr').css('margin', '0');
                jQuery('.donation-security').closest('.v_fr').css('padding', '0.5rem 0');
                jQuery(window).trigger('resize').trigger('scroll');
            } else {
                clearInterval(checkExist);
            }
        }, 1000);

        var thankYou = setInterval(function () {
            if ($('.v_txm').length) {
                jQuery('.certificate_form').slideDown();
                clearInterval(thankYou);
            }
        }, 100);
    });
});